<template>
  <div class="order-line-qr" v-if='order'>
    <div v-show='!readyToSign'>
      <div v-show='!readyAggreement'>
        <p>Line 友だち登録</p>
        <div class="qr">
          <img src="https://qr-official.line.me/gs/M_159zgxsf_BW.png">
        </div>
        <button class="btn"
                @click='finish'>
          {{ buttonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['step','order'],
  name:'LineQr',
  data: function() {
    return {
      loading: false,
      signed: false,
    };
  },
  computed: {
    buttonText: function () {
      return this.step === 'payment' ? '次へ' : 'トップへ';
    },
  },
  methods: {
    finish: async function() {
      let to_path = this.step === 'payment' ? 'campaigninfo' : 'orderSteps';
      this.$router.push({name: to_path})
    },
  },
  created: function() {
    if (!this.order)
      this.$router.push({name: 'orderSteps', params: this.$route.params});
  },
  mounted: function() {
    this.$$.context({
      previous: 'トップへ',
      title: "ID:"+this.$route.params.id,
      previousRouteName: 'orderSteps',
    });
  }
}
</script>

<style lang='scss'>
.order-line-qr {
  padding: 16px;
  text-align: center;
  margin-bottom: 100px;
  p {
    text-align: left;
    margin-bottom: .5em;
  }
  .qr img {
    display: block;
    width: 90%;
    height: auto;
    margin: 0 auto;
  }
}
</style>